module.exports = __webpack_public_path__ + "static/media/allow.af5cc80d.mp3";